"use client";

import { queryOptions } from "@tanstack/react-query";
import { Map } from "immutable";
import { Person } from "@/interfaces/person";

export interface PersonWithVoices extends Person {
  voices: { id: number }[];
}

export const personsSearchByNameOptions = (nameQuery: string) => {
  return queryOptions({
    queryKey: ["persons", { nameQuery }],
    queryFn: async () => {
      if (!nameQuery || nameQuery.trim().length < 2) {
        return [];
      }

      const searchParams = new URLSearchParams({ name: nameQuery });
      const response = await fetch(`/api/persons?${searchParams}`);

      if (!response.ok) {
        throw new Error("Failed to fetch persons");
      }

      const data: PersonWithVoices[] = await response.json();
      return data;
    },
    enabled: nameQuery.trim().length >= 2,
  });
};

export const personsMapOptions = () => {
  return queryOptions<
    Map<number, Person>,
    Error,
    Map<number, Person>,
    [string]
  >({
    queryKey: ["persons"],
    queryFn: () => Map(),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: false,
  });
};

export const personTitleSearchOptions = (query: string) => {
  return queryOptions({
    queryKey: ["personTitle", { query }],
    queryFn: async () => {
      const response = await fetch(
        `/api/persons/titles?${new URLSearchParams({ query })}`,
      );
      const data: { result_count: number; result_examples: string[] } =
        await response.json();
      return data;
    },
    enabled: query.trim().length >= 2,
  });
};

export const personOrganizationSearchOptions = (query: string) => {
  return queryOptions({
    queryKey: ["personOrganization", { query }],
    queryFn: async () => {
      const response = await fetch(
        `/api/persons/organizations?${new URLSearchParams({ query })}`,
      );
      const data: { result_count: number; result_examples: string[] } =
        await response.json();
      return data;
    },
    enabled: query.trim().length >= 2,
  });
};
